export const INSERE_DADOS = 'insere_dados';
export const CLEAR_ALL = 'deleta_todos_dados';
export const CLEAR_2_TO_8 = 'deleta_da_2_ate_8';
export const CLEAR_3_TO_8 = 'deleta_da_3_ate_8';
export const CLEAR_4_TO_8 = 'deleta_da_4_ate_8';
export const CLEAR_5_TO_8 = 'deleta_da_5_ate_8';
export const CLEAR_6_TO_8 = 'deleta_da_6_ate_8';
export const CLEAR_7_TO_8 = 'deleta_da_7_ate_8';
